export default "__VITE_ASSET__POcUoFxb__"